import {valueValidatableInitialize, valueValidatableClearance} from './valueValidatableInitialize';

const textAreaInputInitialize = (RMI, contextId, compId) => valueValidatableInitialize(RMI, contextId, compId);

const textAreaInputClearance = (RMI, contextId, compId) => valueValidatableClearance(RMI, contextId, compId);

export {textAreaInputInitialize, textAreaInputClearance};
